import { initializeApp, getApps, FirebaseApp } from 'firebase/app';
import {
  getMessaging,
  isSupported as isMessagingSupported,
} from 'firebase/messaging';
import { Capacitor } from '@capacitor/core';
import firebaseProdConfig from './firebase_config/firebase.production.config.json';
import firebaseStagConfig from './firebase_config/firebase.staging.config.json';
import { db } from './firestore-wrapper';
import { storage } from './storage-wrapper';

const firebaseConfig =
  process.env.REACT_APP_ENV === 'staging'
    ? firebaseStagConfig
    : firebaseProdConfig;

export { db };
export { storage };

if (typeof window !== 'undefined') {
  const existingApps = getApps();
  if (existingApps.length === 0) {
    initializeApp(firebaseConfig);
  }
}

// Provide a messaging export that works for both web (firebase/messaging)
// and native (Capacitor plugin @capacitor-firebase/messaging).
let messaging: any = null;

if (Capacitor.isNativePlatform && Capacitor.isNativePlatform()) {
  try {
    const capMessaging = require('@capacitor-firebase/messaging').FirebaseMessaging;
    // expose a thin wrapper so consumer code can call `getToken` and subscribe to messages
    messaging = {
      _isNative: true,
      _plugin: capMessaging,
      async getToken() {
        const res = await capMessaging.getToken();
        return res.token ?? res;
      },
      addListener(eventName: string, cb: any) {
        // typical eventName: 'messageReceived'
        const listener = capMessaging.addListener(eventName, cb);
        return listener;
      },
      removeListener: (listenerRef: any) => {
        if (listenerRef && typeof listenerRef.remove === 'function') listenerRef.remove();
      },
    };
  } catch (e) {
    console.warn('@capacitor-firebase/messaging plugin not available', e);
  }
} else {
  const messagingSupported =
    typeof window !== 'undefined' &&
    typeof navigator !== 'undefined' &&
    'serviceWorker' in navigator;

  if (messagingSupported) {
    isMessagingSupported().then((supported) => {
      if (supported) {
        let app: FirebaseApp;
        const existingApps = getApps();
        if (existingApps.length > 0) {
          app = existingApps[0];
        } else {
          app = initializeApp(firebaseConfig);
        }
        messaging = getMessaging(app);
      }
    });
  }
}

export { messaging };
